import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const EmptyWidgetIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        d="M3 4.05662C3 3.47306 3.47306 3 4.05661 3V4.05662H3Z"
        fill="currentColor"
      />
      <path d="M3 5.11323H4.05661V6.16985H3V5.11323Z" fill="currentColor" />
      <path
        d="M4.05661 7.22646H3V8.28308H4.05661V7.22646Z"
        fill="currentColor"
      />
      <path
        d="M3 9.33969H4.05661V10.3963C3.47306 10.3963 3 9.92324 3 9.33969Z"
        fill="currentColor"
      />
      <path d="M6.16984 3H5.11323V4.05662H6.16984V3Z" fill="currentColor" />
      <path
        d="M5.11323 9.33969H6.16984V10.3963H5.11323V9.33969Z"
        fill="currentColor"
      />
      <path d="M8.28306 3H7.22645V4.05662H8.28306V3Z" fill="currentColor" />
      <path
        d="M7.22645 9.33969H8.28306V10.3963H7.22645V9.33969Z"
        fill="currentColor"
      />
      <path
        d="M10.3963 4.05662C10.3963 3.47306 9.92323 3 9.33968 3V4.05662H10.3963Z"
        fill="currentColor"
      />
      <path
        d="M9.33968 5.11323H10.3963V6.16985H9.33968V5.11323Z"
        fill="currentColor"
      />
      <path
        d="M10.3963 7.22646H9.33968V8.28308H10.3963V7.22646Z"
        fill="currentColor"
      />
      <path
        d="M9.33968 9.33969H10.3963C10.3963 9.92324 9.92323 10.3963 9.33968 10.3963V9.33969Z"
        fill="currentColor"
      />
      <path
        d="M12.5095 4.05662C12.5095 3.47306 12.9826 3 13.5661 3V4.05662H12.5095Z"
        fill="currentColor"
      />
      <path
        d="M12.5095 5.11323H13.5661V6.16985H12.5095V5.11323Z"
        fill="currentColor"
      />
      <path
        d="M13.5661 7.22646H12.5095V8.28308H13.5661V7.22646Z"
        fill="currentColor"
      />
      <path
        d="M12.5095 9.33969H13.5661V10.3963C12.9826 10.3963 12.5095 9.92324 12.5095 9.33969Z"
        fill="currentColor"
      />
      <path d="M15.6794 3H14.6227V4.05662H15.6794V3Z" fill="currentColor" />
      <path
        d="M14.6227 9.33969H15.6794V10.3963H14.6227V9.33969Z"
        fill="currentColor"
      />
      <path d="M17.7926 3H16.736V4.05662H17.7926V3Z" fill="currentColor" />
      <path
        d="M16.736 9.33969H17.7926V10.3963H16.736V9.33969Z"
        fill="currentColor"
      />
      <path
        d="M19.9058 4.05662C19.9058 3.47306 19.4327 3 18.8492 3V4.05662H19.9058Z"
        fill="currentColor"
      />
      <path
        d="M18.8492 5.11323H19.9058V6.16985H18.8492V5.11323Z"
        fill="currentColor"
      />
      <path
        d="M19.9058 7.22646H18.8492V8.28308H19.9058V7.22646Z"
        fill="currentColor"
      />
      <path
        d="M18.8492 9.33969H19.9058C19.9058 9.92324 19.4327 10.3963 18.8492 10.3963V9.33969Z"
        fill="currentColor"
      />
      <path
        d="M11.7249 15.4605C11.3122 15.8732 11.3122 16.5422 11.7249 16.9548L12.472 16.2077L11.7249 15.4605Z"
        fill="currentColor"
      />
      <path
        d="M13.2192 16.9548L12.472 17.702L13.2192 18.4491L13.9663 17.702L13.2192 16.9548Z"
        fill="currentColor"
      />
      <path
        d="M13.9663 19.1963L14.7134 18.4491L15.4606 19.1963L14.7134 19.9434L13.9663 19.1963Z"
        fill="currentColor"
      />
      <path
        d="M16.2077 19.9434L15.4606 20.6905C15.8732 21.1032 16.5422 21.1032 16.9548 20.6905L16.2077 19.9434Z"
        fill="currentColor"
      />
      <path
        d="M12.472 14.7134L13.2192 13.9663L13.9663 14.7134L13.2192 15.4605L12.472 14.7134Z"
        fill="currentColor"
      />
      <path
        d="M17.702 18.4491L16.9548 19.1963L17.702 19.9434L18.4491 19.1963L17.702 18.4491Z"
        fill="currentColor"
      />
      <path
        d="M13.9663 13.2191L14.7134 12.472L15.4606 13.2191L14.7134 13.9663L13.9663 13.2191Z"
        fill="currentColor"
      />
      <path
        d="M19.1963 16.9548L18.4491 17.702L19.1963 18.4491L19.9434 17.702L19.1963 16.9548Z"
        fill="currentColor"
      />
      <path
        d="M15.4606 11.7249C15.8732 11.3122 16.5422 11.3122 16.9548 11.7249L16.2077 12.472L15.4606 11.7249Z"
        fill="currentColor"
      />
      <path
        d="M17.702 12.472L16.9548 13.2191L17.702 13.9663L18.4491 13.2191L17.702 12.472Z"
        fill="currentColor"
      />
      <path
        d="M18.4491 14.7134L19.1963 13.9663L19.9434 14.7134L19.1963 15.4605L18.4491 14.7134Z"
        fill="currentColor"
      />
      <path
        d="M20.6905 15.4605L19.9434 16.2077L20.6905 16.9548C21.1032 16.5422 21.1032 15.8732 20.6905 15.4605Z"
        fill="currentColor"
      />
      <path
        d="M3 13.5662C3 12.9826 3.47306 12.5095 4.05661 12.5095V13.5662H3Z"
        fill="currentColor"
      />
      <path d="M3 14.6228H4.05661V15.6794H3V14.6228Z" fill="currentColor" />
      <path d="M4.05661 16.736H3V17.7926H4.05661V16.736Z" fill="currentColor" />
      <path
        d="M3 18.8492H4.05661V19.9058C3.47306 19.9058 3 19.4328 3 18.8492Z"
        fill="currentColor"
      />
      <path
        d="M6.16984 12.5095H5.11323V13.5662H6.16984V12.5095Z"
        fill="currentColor"
      />
      <path
        d="M5.11323 18.8492H6.16984V19.9058H5.11323V18.8492Z"
        fill="currentColor"
      />
      <path
        d="M8.28306 12.5095H7.22645V13.5662H8.28306V12.5095Z"
        fill="currentColor"
      />
      <path
        d="M7.22645 18.8492H8.28306V19.9058H7.22645V18.8492Z"
        fill="currentColor"
      />
      <path
        d="M10.3963 13.5662C10.3963 12.9826 9.92323 12.5095 9.33968 12.5095V13.5662H10.3963Z"
        fill="currentColor"
      />
      <path
        d="M9.33968 14.6228H10.3963V15.6794H9.33968V14.6228Z"
        fill="currentColor"
      />
      <path
        d="M10.3963 16.736H9.33968V17.7926H10.3963V16.736Z"
        fill="currentColor"
      />
      <path
        d="M9.33968 18.8492H10.3963C10.3963 19.4328 9.92323 19.9058 9.33968 19.9058V18.8492Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default EmptyWidgetIcon;
